import { getEnv } from "../lib/env";

const env = getEnv();

export class ApiError extends Error {
  status: number;
  code: string | null;

  constructor(method: string, path: string, status: number, message?: string, code?: string | null) {
    super(message ?? `${method} ${path} failed: ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.code = code ?? null;
  }
}

async function apiRequest<TResponse>(method: string, path: string, body?: unknown): Promise<TResponse> {
  const requestInit: RequestInit = {
    method,
    credentials: "include"
  };

  if (body !== undefined) {
    requestInit.headers = { "Content-Type": "application/json" };
    requestInit.body = JSON.stringify(body);
  }

  const response = await fetch(`${env.apiBaseUrl}${path}`, requestInit);

  if (!response.ok) {
    let payload: { code?: string; message?: string } | null = null;

    try {
      payload = (await response.json()) as { code?: string; message?: string };
    } catch {
      payload = null;
    }

    throw new ApiError(method, path, response.status, payload?.message, payload?.code ?? null);
  }

  return response.json() as Promise<TResponse>;
}

export async function apiGet<T>(path: string): Promise<T> {
  return apiRequest<T>("GET", path);
}

export async function apiPost<TRequest, TResponse>(path: string, body: TRequest): Promise<TResponse> {
  return apiRequest<TResponse>("POST", path, body);
}

export async function apiPatch<TRequest, TResponse>(path: string, body: TRequest): Promise<TResponse> {
  return apiRequest<TResponse>("PATCH", path, body);
}
